module.exports = __webpack_public_path__ + "img/Planta rebaixada com novos sintomas.a2051d69.webp";